module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "container"
  }, [_c('affiliate-policy-content')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-68dd7e7c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/affiliatePolicy/Index.vue
// module id = 1343
// module chunks = 1